import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";
import { Interaction } from "../@types/Interaction";

export interface Props {
  children: React.ReactNode | React.ReactNode[];
}

export interface IPostContext {
  interactions: Interaction[];
  setInteractions: Dispatch<SetStateAction<Interaction[]>>;
}

export const PostContext = createContext<IPostContext>({} as IPostContext);

export const PostProvider = ({ children }: Props) => {
  const [interactions, setInteractions] = useState<Interaction[]>([]);

  return (
    <PostContext.Provider value={{ interactions, setInteractions }}>
      {children}
    </PostContext.Provider>
  );
};

export default function usePostContext() {
  const context = useContext(PostContext);

  if (!context) {
    throw new Error("usePostContext must be used within an App");
  }

  return context;
}
